import { render, staticRenderFns } from "./AssessmentGroupBandDetail.vue?vue&type=template&id=1fda0a0d&scoped=true"
import script from "./AssessmentGroupBandDetail.vue?vue&type=script&lang=js"
export * from "./AssessmentGroupBandDetail.vue?vue&type=script&lang=js"
import style0 from "./AssessmentGroupBandDetail.vue?vue&type=style&index=0&id=1fda0a0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fda0a0d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VList,VListItem,VListItemTitle,VMenu,VTextField})
